import dateFnsFormat from 'date-fns/format'
import { formatCurrency2String } from 'src/utils/number/currency'

import {
  DEFAULT_INTERVAL_PIXELS,
  DEFAULT_X_AXIS_TIMESTAMP_FORMAT,
} from './consts'

const INPUT_DATE_FORMAT = 'yyyy-MM-dd'

export const formatDateToInputFormat = (datetime: number): string =>
  dateFnsFormat(new Date(datetime), INPUT_DATE_FORMAT)

interface PeriodNumberMaps {
  [id: string]: number
}

interface PeriodStringMaps {
  [id: string]: string
}

const intervalPixelsMap: PeriodNumberMaps = {
  '5m': 200,
  '15m': 200,
  '1h': 200,
  '2h': 200,
  '24h': 200,
}

const intervalDateMinRangeMap: PeriodNumberMaps = {
  '5m': 3600 * 1000 * 2,
  '15m': 3600 * 1000 * 6,
  '30m': 3600 * 1000 * 12,
  '1h': 3600 * 1000 * 24,
  '2h': 3600 * 1000 * 48,
  '24h': 3600 * 1000 * 72,
  '7d': 3600 * 1000 * 24 * 30,
  '30d': 3600 * 1000 * 90,
}

const intervalXAxisFormat: PeriodStringMaps = {
  '5m': 'MMM DD HH:mm',
  '15m': 'MMM DD HH:mm',
  '1h': 'MMM DD',
  '2h': "MMM 'YY",
  '24h': "MMM 'YY",
}

interface MapOfTimeFuncByPeriod {
  [id: string]: () => number
}

const getTimeFromByPeriod: MapOfTimeFuncByPeriod = {
  '5m': () => Date.now() - 3600 * 1000 * 24,
  '15m': () => Date.now() - 3600 * 1000 * 24 * 7,
  '1h': () => Date.now() - 3600 * 1000 * 24 * 30,
  '2h': () => Date.now() - 3600 * 1000 * 24 * 90,
  '24h': () => Date.now() - 3600 * 1000 * 24 * 365,
}

const frameIntervals: PeriodNumberMaps = {
  '2d': 3600 * 1000 * 24 * 2,
  '7d': 3600 * 1000 * 24 * 7,
  '3m': 3600 * 1000 * 24 * 90,
  '1y': 3600 * 1000 * 24 * 365,
  all: 3600 * 1000 * 24 * 365 * 2,
}

export const getDateTickPixelInterval = (choosenPeriod: string): number =>
  intervalPixelsMap[choosenPeriod] || DEFAULT_INTERVAL_PIXELS

export const getDateMinRange = (choosenPeriod: string): number =>
  intervalDateMinRangeMap[choosenPeriod]

export const getDateLabelFormat = (choosenPeriod: string): string =>
  intervalXAxisFormat[choosenPeriod] || DEFAULT_X_AXIS_TIMESTAMP_FORMAT

export const getDateInterval = (period: string): number =>
  getTimeFromByPeriod[period] ? getTimeFromByPeriod[period]() : Date.now()

export const getFramByInteral = (interval: number) => {
  const dateIntervals = frameIntervals
  let closestFrame

  if (interval < dateIntervals['2d']) {
    closestFrame = '5m'
  } else if (interval < dateIntervals['7d']) {
    closestFrame = '15m'
  } else if (interval < dateIntervals['3m']) {
    closestFrame = '1h'
  } else if (interval < dateIntervals['1y']) {
    closestFrame = '2h'
  } else if (interval < dateIntervals['all']) {
    closestFrame = '24h'
  } else {
    closestFrame = 'all'
  }

  return closestFrame
}

export const xAxisLabelFormat = function (
  value: number,
  period: string
): string {
  return `<span class="Chart-label-x">${dateFnsFormat(
    new Date(value),
    getDateLabelFormat(period)
  )}</span>`
}

export const formatCurrency = (number: number, withoutFloat: boolean) =>
  formatCurrency2String(number, false, `0,0${withoutFloat ? '' : '.00'}`)

// const INPUT_DATE_FORMAT = 'YYYY-MM-DD'

// const rounding = (value, count) => {
//   const mod = value % count
//   return mod > count / 2 ? value + (count - mod) : value - mod
// }

// const roundTimestampToHours = (timestamp, count) =>
//   setHours(setMinutes(timestamp, 0), rounding(getHours(timestamp), count))

// const roundTimestampToMinutes = (timestamp, count) => setMinutes(timestamp, rounding(getMinutes(timestamp), count))

// export const getBandPoints = (min, max, choosenPeriod) => {
//   const step = {
//     '5m': 3600 * 1000 * 12,
//     '15m': 3600 * 1000 * 24,
//     '30m': 3600 * 1000 * 24 * 2,
//     '1h': 3600 * 1000 * 24 * 4,
//     '24h': 3600 * 1000 * 24 * 8,
//     '7d': 3600 * 1000 * 24 * 28,
//     '30d': 3600 * 1000 * 24 * 120,
//   }[choosenPeriod]

//   const bandPoints = []
//   let pointChart = min

//   while (max > pointChart) {
//     bandPoints.push({
//       from: pointChart,
//       to: pointChart + step / 2,
//       color: 'rgba(255, 255, 255, 0.03)',
//     })
//     pointChart += step
//   }

//   return bandPoints
// }

// export const getDateLabelFormat = choosenPeriod => {
//   return (
//     {
//       '5m': 'MMM DD HH:mm',
//       '15m': 'MMM DD HH:mm',
//       '1h': 'MMM DD',
//       '2h': "MMM 'YY",
//       '24h': "MMM 'YY",
//     }[choosenPeriod] || "MMM 'YY"
//   )
// }

// export const getDateMinRange = choosenPeriod => {
//   return {
//     '5m': 3600 * 1000 * 2,
//     '15m': 3600 * 1000 * 6,
//     '30m': 3600 * 1000 * 12,
//     '1h': 3600 * 1000 * 24,
//     '2h': 3600 * 1000 * 48,
//     '24h': 3600 * 1000 * 72,
//     '7d': 3600 * 1000 * 24 * 30,
//     '30d': 3600 * 1000 * 90,
//   }[choosenPeriod]
// }

// export const getDateInterval = choosenPeriod => {
//   const timestamp = Date.now()
//   return (
//     {
//       '5m': timestamp - 3600 * 1000 * 24,
//       '15m': timestamp - 3600 * 1000 * 24 * 7,
//       '1h': timestamp - 3600 * 1000 * 24 * 30,
//       '2h': timestamp - 3600 * 1000 * 24 * 90,
//       '24h': timestamp - 3600 * 1000 * 24 * 365,
//     }[choosenPeriod] || timestamp
//   )
// }

// export const getDateTooltipFormat = () => 'dddd, DD MMM YYYY, HH:mm UTCZ'

// export const getDateTooltipClass = choosenPeriod => {
//   return (
//     {
//       '5m': 'Chart-tooltip-x-text-time',
//       '15m': 'Chart-tooltip-x-text-time',
//       '1h': 'Chart-tooltip-x-text-time',
//       '2h': 'Chart-tooltip-x-text-time',
//       '24h': 'Chart-tooltip-x-text-time',
//     }[choosenPeriod] || 'Chart-tooltip-x-text'
//   )
// }

// export const roundDate = (choosenPeriod, timestamp) => {
//   return ({
//     '5m': roundTimestampToMinutes.bind(null, timestamp, 5),
//     '15m': roundTimestampToMinutes.bind(null, timestamp, 15),
//     '1h': roundTimestampToHours.bind(null, timestamp, 1),
//     '2h': roundTimestampToHours.bind(null, timestamp, 2),
//     '24h': roundTimestampToHours.bind(null, timestamp, 24),
//   }[choosenPeriod] || (() => timestamp))()
// }

// export const formatCurrency = (number, withoutFloat) =>
//   formatCurrency2String(number, false, `0,0${withoutFloat ? '' : '.00'}`)

// export const formatDateToInputFormat = datetime => dateFnsFormat(new Date(datetime), INPUT_DATE_FORMAT)
